import { useContext } from "react";
import { Box, Typography, Input, IconButton, Avatar, TextField } from "@mui/material";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { b64 } from "../../../../../core/encryption/B64";
import { ValidUrl } from "../../../../../core/validator/Validator"
import { Delete as DeleteIcon } from '@mui/icons-material';

export const PropertyImages = () => {
    const { realproperty_state } = useContext(ToolContext);
    const { otherInfrmtn } = realproperty_state;

    const handleCoverPhotoChange = async (e) => {
        // using the "[0]" for displaying the current cvr photo selected and only "file" for S3 function to get the link
        const file = Array.from(e.target.files);
        if (file[0]) {
            b64(file[0]).then((base64) => {
                otherInfrmtn.set({
                    ...otherInfrmtn.data,
                    propertyCoverPhoto: {
                        ...otherInfrmtn.data.propertyCoverPhoto,
                        b64Img: base64,
                        objectImg: file,
                        stat: false,
                        link: "",
                        name: file[0].name, 
                        type: file[0].type, 
                        size: file[0].size, 
                        photo_type: 2, 
                        youtube_link: "",
                    },
                });
                e.target.value = "";
            });
        }
    };
    // for more photos handler display
    const handleMorePhotos = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            Promise.all(files?.map((file) => b64(file))).then((base64Strings) => {
                otherInfrmtn.set({
                    ...otherInfrmtn.data,
                    morePhotos: {
                        ...otherInfrmtn.data.morePhotos,
                        b64Imgs: [...(otherInfrmtn.data.morePhotos.b64Imgs || []), ...base64Strings],
                        imgProperties: [...(otherInfrmtn.data.morePhotos.imgProperties || []), 
                            {
                                objectImg: files,
                                link: "",
                                name: files[0].name, 
                                type: files[0].type, 
                                size: files[0].size, 
                                photo_type: 1, 
                                youtube_link: "",
                            }
                        ],
                        stat: false,
                    },
                });
            });
        }
    };
    // for removing photo handler
    const handleRemovePhoto = (index, photoId) => {
        const { photos = [], morePhotos = {} } = otherInfrmtn.data;
        const { b64Imgs = [], imgProperties = [] } = morePhotos;
        const morePhoto = photos.filter(v => v.photo_type === 1);
        const coverPhoto = photos.filter(v => v.photo_type === 2);
        const activeMorePhotos = morePhoto.filter(v => v.active === 1 && v.data_status === "InUse");

        if (index < activeMorePhotos.length) {
            otherInfrmtn.set(p => ({
                ...p,
                photos: [
                    ...coverPhoto,
                    ...morePhoto.map(photo =>
                        photo.id === photoId
                            ? { ...photo, active: 0, data_status: 'IsDeleted' }
                            : photo
                    ),
                ],
            }));
            return;
        }

        const newIndex = index - activeMorePhotos.length;
        otherInfrmtn.set(p => ({
            ...p,
            morePhotos: {
                ...p.morePhotos,
                b64Imgs: b64Imgs.filter((_, i) => i !== newIndex),
                imgProperties: imgProperties.filter((_, i) => i !== newIndex),
            },
        }));
    };

    const dsplyMorePhotos = () => {
        const existingPhotos = otherInfrmtn.data.photos?.filter(v => v.photo_type === 1 && v.active === 1 && v.data_status === "InUse").map(v => ({ isLink: true, value: v.link, id: v.id })) || [];
        const newPhotos = otherInfrmtn.data.morePhotos.b64Imgs?.map(v => ({ isLink: false, value: v, id: null })) || [];
        const phts = [...existingPhotos, ...newPhotos];
        return (
           phts.map((v, i) => (
                <Box key={i} sx={{ width: "100%", height: "9.375rem", borderRadius: "8px", position: "relative"}}>
                    <Avatar src={v.isLink ? v.value : `data:image/jpeg;base64,${v.value}`} alt={`Additional Pic ${i + 1}`}
                        sx={{ 
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                        }}
                    />
                    <IconButton size="small" onClick={() => handleRemovePhoto(i, v.id)} sx={{ position: "absolute", top: 5, right: 5, backgroundColor: "rgba(0,0,0,0.5) !important", color: "white",}}>
                        <DeleteIcon fontSize="small"></DeleteIcon>
                    </IconButton>
                </Box>
            ))
        )
    } 
    // handle yt video link validator
    const handleYoutubeLink = (e) => {
        const { name, value } = e.target
        const isValid = ValidUrl(value);
        otherInfrmtn.set({
            ...otherInfrmtn.data,
            [name]: {
                ...otherInfrmtn.data[name],
                value, 
                stat: !!value && !isValid,
                msg: value && !isValid ? "Please enter a proper youtube link!" : "",
            }
        });
    }
    return (
         <>
            <Typography mb="0.5rem">
                Property Cover Photo
                <Typography component="span" color="error">*</Typography>
            </Typography>
            <Box display="flex" justifyContent="center">
                <Box border={`2px dashed ${otherInfrmtn.data.propertyCoverPhoto.stat ? "red" : "grey"}`} height="22rem" marginBottom="1rem" 
                    sx={{             
                        width: "75%",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        position: "relative", 
                    }}>
                    <Input type="file" accept="image/*" onChange={handleCoverPhotoChange}
                        sx={{             
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            opacity: "0",
                            "& .MuiInputBase-input": {
                                height: "100%",
                            }, }}
                    />
                    {otherInfrmtn.data.propertyCoverPhoto.b64Img || otherInfrmtn.data.photos.length !== 0 ? (
                        <Box component="img" src={otherInfrmtn.data.propertyCoverPhoto.objectImg ? `data:image/jpeg;base64,${otherInfrmtn.data.propertyCoverPhoto.b64Img}` : otherInfrmtn.data.photos?.find(v => v.photo_type === 2)?.link} alt="Cover" 
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "8px",
                            }}
                        />
                    ) : (
                        <Typography
                            variant="body1" sx={{color: `${otherInfrmtn.data.propertyCoverPhoto.stat ? "red" : "rgba(0, 0, 0, 0.87)"}`}}
                        >
                            Upload photos as jpg or png.
                        </Typography>
                    )}
                </Box>
            </Box>
            <Typography mb="0.5rem">
                More Photos
                <Typography component="span" color="error">*</Typography>
            </Typography>
            <Box mb="1rem" sx={{ display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(2, 1fr)",
                        sm: "repeat(3, 1fr)",
                        md: "repeat(4, 1fr)",
                        lg: "repeat(5, 1fr)",
                    }, gap: 2,
                }}
            >
                {dsplyMorePhotos()}
                <Box height="9.375rem" border={`2px dashed ${otherInfrmtn.data.morePhotos.stat ? "red" : "grey"}`} 
                    sx={{
                        width: "100%",
                        borderRadius: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        position: "relative",
                    }}
                >
                    <Input type="file" accept="image/*" multiple onClick={(e) => (e.target.value = "")} onChange={handleMorePhotos} 
                        sx={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            opacity: "0",
                            "& .MuiInputBase-input": {
                                height: "100%",
                            },
                        }}
                    />
                    <Typography variant="body1" sx={{ color: `${otherInfrmtn.data.morePhotos.stat ? "red" : "rgba(0, 0, 0, 0.87)"}` }}>Add Photo</Typography>
                </Box>
            </Box>
            <Typography mb="0.5rem">
                 Youtube video link of your property
            </Typography>
            <TextField name="youtubeLink" value={otherInfrmtn.data.youtubeLink.value} onChange={handleYoutubeLink} label={ otherInfrmtn.data.youtubeLink.value === "" && "Input link here . . ."} error={otherInfrmtn.data.youtubeLink.stat} helperText={otherInfrmtn.data.youtubeLink.stat ? otherInfrmtn.data.youtubeLink.msg : ""} variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} InputLabelProps={{ shrink: false }}/>
        </>
    )
}
